import(/* webpackMode: "eager" */ "/vercel/path0/src/app/auth/forget-password/page.tsx");
